/**
 * Meter — хувь харуулах индикатор (хэвтээ тууз ба босоо багана).
 *
 * ⚠️ ДАШБОАРДЫН ЦОРЫН ГАНЦ `style` АТРИБУТУУД ЭНД БАЙНА.
 *    Урт нь өгөгдлөөс гардаг тул Tailwind class-аар илэрхийлэх
 *    боломжгүй — class нь build үед статик байх ёстой. Тиймээс
 *    хуудсууд өөрсдөө `style={{ width }}` бичихийн оронд эдгээр
 *    компонентыг дуудна: inline style хоёрхон газар төвлөрч, өнгө
 *    нь бүрэн токеноор явна.
 */

const TONE = {
  accent: 'bg-accent',
  'accent-soft': 'bg-accent-300',
  alert: 'bg-alert',
  warn: 'bg-warn-ink',
  neutral: 'bg-ink-3',
} as const;

export type MeterTone = keyof typeof TONE;

export function Meter({
  value,
  tone = 'accent',
  size = 'md',
  label,
  className = '',
}: {
  /** 0–100. Хязгаараас гарсан утгыг өөрөө таслана. */
  value: number;
  tone?: MeterTone;
  size?: 'sm' | 'md' | 'lg';
  /** Дэлгэц уншигчид зориулсан тайлбар. Байхгүй бол чимэглэл гэж үзнэ. */
  label?: string;
  className?: string;
}) {
  const pct = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 0));
  const height = size === 'sm' ? 'h-[5px]' : size === 'lg' ? 'h-2' : 'h-1.5';

  // Утга 0 биш мөртлөө маш бага үед туузыг харагдахуйц үлдээнэ —
  // «1 ширхэг» ба «0 ширхэг» хоёр ялгаатай харагдах ёстой.
  const width = pct > 0 && pct < 2 ? 2 : pct;

  return (
    <div
      className={`${height} overflow-hidden rounded-pill bg-track ${className}`}
      {...(label
        ? { role: 'progressbar', 'aria-valuenow': Math.round(pct), 'aria-valuemin': 0, 'aria-valuemax': 100, 'aria-label': label }
        : { 'aria-hidden': true })}
    >
      <div className={`h-full rounded-pill ${TONE[tone]}`} style={{ width: `${width}%` }} />
    </div>
  );
}
